<div class="mobile-promo">
  <div class="content">
    <img class="logo" src="/assets/images/app-logo.svg" />
    <ng-container *ngIf="isMobile; else isDesktop">
      <button (click)="goToDeepLink()" class="ui-button fit-width">{{ 'general.open' | translate }}</button>
    </ng-container>
    <ng-template #isDesktop>
      <img src="/assets/images/mockups.png" />
      <div class="stores">
        <img *ngFor="let store of ['app-store', 'play-store']" (click)="goTo(store)" [src]="'/assets/images/' + store + '.svg'" />
      </div>
    </ng-template>
    <img class="close" (click)="close('[Button] Close mobile promotion banner')" src="/assets/images/icons/close.svg" />
  </div>
</div>
